/**
 * creator: dangliming
 * date: 2018年1月12日11:27:50
 * description: 权限管理 用于各模块下 需传入moduleId, conditionType, appId
 */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Tooltip, message, Spin } from 'antd';
// import { callApi, localStorage, addQueryParams } from 'utils';
import { callApi } from '../../../../utils/callApi/rest';
import localStorage from '../../../../utils/localStorage';
import addQueryParams from '../../../../utils/addQueryParams';
import { api } from '../../config';
import './index.less';
import { CommunityScopeEnum } from '../right-detail/index';

const OWNER_TYPE_EH = 'EhOrganizations';
const MODULE_CONTROL_TYPE_PLATFORM = 'platform_control';
const prefixCls = 'eh-right-management';

class AuthorizeByRule extends PureComponent {
	constructor(props) {
		super(props);
		let { ownerId, ownerType = OWNER_TYPE_EH, scopeType, showProjectScope, showDepartmentScope } = props;
		const { appId, organizationId, namespaceId, moduleControlType } = window.$$context;
		ownerId = ownerId || organizationId;
		let defaultTargetType = '',
			showProject = showProjectScope,
			showDepartment = showDepartmentScope;
		// 业务没设置是否展示管理项目范围时，如果是园区应用，默认展示；否则，不展示
		if (showProject === undefined) {
			showProject = moduleControlType === 'community_control';
		}
		// 业务没设置是否展示管理企业范围时，如果是企业应用，默认展示；否则，不展示
		if (showDepartment === undefined) {
			showDepartment = moduleControlType === 'org_control';
		}
		// if (moduleControlType === 'community_control') {
		// 	defaultTargetType = 'project';
		// } else if (moduleControlType === 'org_control') {
		// 	defaultTargetType = 'department';
		// }
		// scopeType = scopeType || defaultTargetType;
		this.state = {
			ownerId,
			ownerType,
			appId,
			namespaceId,
			organizationId,
			allPrivileges: [], // 全部权限
			rules: [], // 列表数据 规则数组
			deleteIndex: -1, // 要删除的数据的索引
			showLoading: true, // 请求中
			scopeType, // 数据范围类型
			totalNum: 0, // 使用新的分页组件,
			projectsMap: new Map(), // 所有项目的 id -- 项目项 映射
			departmentsMap: new Map(), // 所有部门的 id -- name 映射
			// 是否展示‘管理项目范围’
			showProject,
			// 是否展示‘管理企业范围’
			showDepartment,
		};
	}

	componentDidMount() {
		const { appId, namespaceId, organizationId } = this.state;
		if (window.$$context.moduleId && appId && namespaceId && organizationId) {
			Promise.all([
				this.getCommunityMap(),
				this.getDepartmentMap(),
				this.listServiceModulePrivileges(),
				this.listAuthorizationRelations(),
			]).finally(() => {
				this.setState({ showLoading: false });
			});
		}
	}

	/********* api start********/
	// 获取所有项目的 projectId -- projectName 映射
	getCommunityMap = () => {
		const { namespaceId, organizationId } = window.$$context;
		return callApi({
			api: api.getSpaceMap,
			data: {
				namespaceId,
				organizationId,
			},
		})
			.then((res) => {
				const projectsMap = new Map();
				const { spaceGroups = [] } = res || {};
				spaceGroups.map((item) => {
					const { spaceType } = item;
					const id = spaceType === 1 ? `group${item.id}` : item?.communityId.toString();
					projectsMap.set(id, item);
				});
				this.setState({ projectsMap });
			})
			.catch((err) => {
				message.error(`获取空间项目数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
			});
	};

	// 获取所有部门的 id -- name 映射
	getDepartmentMap = () => {
		const { namespaceId, organizationId } = window.$$context;
		return callApi({
			api: api.getDepartments,
			data: { namespaceId, orgId: organizationId },
			defaultError: false,
		})
			.then((res) => {
				const departmentsMap = new Map();
				for (const item of res) {
					departmentsMap.set(item.id, item.name);
				}
				this.setState({ departmentsMap });
			})
			.catch((err) => {
				message.error(`获取部门数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
			});
	};

	// 获取数据列表
	listAuthorizationRelations = (pageSize = 9999, pageAnchor) => {
		const { appId, namespaceId, organizationId } = this.state;
		// this.setState({showLoading: true});
		return callApi({
			api: api.getOperationAuthorizations,
			data: { pageAnchor, appId, namespaceId, orgId: organizationId, pageSize },
			// defaultError: false,
		}).then((response) => {
			this.setState({
				rules: response.authorizations || [],
			});
		});
		// 	.catch(err => {
		// 	console.error(err);
		// 	message.error(`获取权限数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
		// });
	};

	// 获取所有权限名称
	listServiceModulePrivileges = () => {
		const { namespaceId, moduleId, organizationId } = window.$$context;
		const param = { moduleId, namespaceId, organizationId };
		return callApi({
			api: api.getOperations,
			data: param,
			defaultError: false,
		})
			.then((response) => {
				this.setState({
					allPrivileges: response.filter((t) => t.operations && t.operations.length > 0),
				});
			})
			.catch((err) => {
				console.error(err);
				message.error(`请求出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
			});
	};
	/********* api end********/

	//  表格显示列项
	// getColumn = () => {
	// 	const { editRule, confirmDelete } = this;
	// 	const { customizeLabel } = this.props;
	// 	const { scopeType, communitiesMap, departmentsMap } = this.state;
	// 	const { moduleControlType } = window.$$context;

	// 	let columns = [{
	// 		title: '序号',
	// 		dataIndex: 'index',
	// 		key: 'index',
	// 		width: 80,
	// 		render: (value, row, index) => (<span>{index + 1}</span>)
	// 	}, {
	// 		title: '名称',
	// 		dataIndex: 'targets',
	// 		key: 'targets',
	// 		render: (value, row, index) => value ? (
	// 			<Tooltip title={value.map(item => item.targetName).join('、')} placement="topLeft">
	// 				<span className={`${prefixCls}-targetName`}>{value.map(item => item.targetName).join('、')}</span>
	// 			</Tooltip>) : '',
	// 		className: `${prefixCls}-table-flag`
	// 	}, {
	// 		title: '数据权限',
	// 		dataIndex: 'assignedDataScope',
	// 		render: (value, row, index) => {
	// 			if (value.allDataScopeFlag) return <span>全部</span>;
	// 			let text = '';
	// 			if (row.customizeDatum) text += scopeType === 'project' ? '项目：' : '部门：';
	// 			if (scopeType === 'project') {
	// 				text = value.dataScopeIds.map(item => {
	// 					return (communitiesMap != null ? communitiesMap.get(item) : `未知项目${item}`);
	// 				}).join('、');
	// 			} else if (scopeType === 'department') {
	// 				text = value.dataScopeIds.map(item => {
	// 					return (departmentsMap != null ? departmentsMap.get(item) : `未知部门${item}`);
	// 				}).join('、');
	// 			}
	// 			let customizeText = `${customizeLabel}：`;
	// 			if (row.customizeDatum) customizeText += `${row.customizeDatum.map(item => item.displayName).join('、')}`;
	// 			return <Tooltip
	// 				placement="topLeft"
	// 				title={<div>
	// 					<span>{`${text}`}</span><br />
	// 					{!!row.customizeDatum && <span>{`${customizeText}`}</span>}
	// 				</div>}
	// 			>
	// 				<p className={`${prefixCls}-dataRange`}>{text}</p><br />
	// 				{!!row.customizeDatum && <p className={`${prefixCls}-dataRange`}>{customizeText}</p>}
	// 			</Tooltip>;
	// 		},
	// 		className: `${prefixCls}-table-flag`
	// 	}, {
	// 		title: '功能权限',
	// 		dataIndex: 'assignedOperations',
	// 		render: (value, row, index) => {
	// 			const text = this.getPrivilegeName(value);
	// 			return <Tooltip title={text} placement="topLeft">
	// 				<span className={`${prefixCls}-privileges`}>{text}</span>
	// 			</Tooltip>;
	// 		},
	// 		className: `${prefixCls}-table-flag`
	// 	}, {
	// 		title: '创建者',
	// 		dataIndex: 'creatorName',
	// 		render: value => value || '--',
	// 		className: `${prefixCls}-table-flag`
	// 	}, {
	// 		title: '操作',
	// 		dataIndex: 'opera',
	// 		key: 'opera',
	// 		width: '12em',
	// 		render: (value, record, index) => {
	// 			return (
	// 				<span>
	// 					{/* <a className={`${prefixCls}-look`} onClick={() => viewRule(record)}>查看</a> */}
	// 					<a className={`${prefixCls}-edit`} onClick={() => editRule(record)}>编辑</a>
	// 					<a onClick={() => confirmDelete(index)}>删除</a>
	// 				</span>
	// 			);
	// 		}
	// 	}];

	// 	// 企业工作台 平台应用 去掉 ‘数据权限’
	// 	if (moduleControlType === MODULE_CONTROL_TYPE_PLATFORM) {
	// 		columns.splice(2, 1);
	// 	}
	// 	return columns;
	// }

	/**
	 * 根据权限ID列表获取对应的权限名称
	 * @param assignedOperations 授权的操作权限
	 */
	getPrivilegeName = (assignedOperations) => {
		if (assignedOperations == null) return;
		const arr = [];
		if (assignedOperations.allOperationFlag === 1) {
			return '全部权限';
		}

		const getOperationName = (id) => {
			for (const category of this.state.allPrivileges) {
				for (const operation of category.operations) {
					if (id === operation.id) {
						return operation.name;
					}
				}
			}
			return '';
		};

		for (const opId of assignedOperations.operationIds) {
			arr.push(getOperationName(opId));
		}

		return arr.join('、');
	};

	// 跳转至添加规则页面 需要把所有权限的数据存入localstorage
	addRule = () => {
		const { match, history } = this.props;
		const nextRoute = `${match.url}/add`;
		localStorage.write('right_management_allPrivileges', JSON.stringify(this.state.allPrivileges));
		history.push(nextRoute);
	};

	// 跳转至查看规则页面 需要把所有权限的数据、已选择的权限的数据存入localstorage
	viewRule = (record) => {
		const { match, history } = this.props;
		const nextRoute = `${match.url}/view`;
		localStorage.write('right_management_allPrivileges', JSON.stringify(this.state.allPrivileges));
		localStorage.write('right_management_record', JSON.stringify(record));
		history.push(nextRoute);
	};

	// 跳转至编辑规则页面 需要把所有权限的数据、已选择的权限的数据存入localstorage
	editRule = (record) => {
		const { assignmentId } = record;
		const { match, history } = this.props;
		const nextRoute = `${match.url}/edit?id=${assignmentId}`;
		localStorage.write('right_management_allPrivileges', JSON.stringify(this.state.allPrivileges));
		localStorage.write('right_management_record', JSON.stringify(record));
		history.push(nextRoute);
	};

	// 显示删除确认框
	confirmDelete = (index) => {
		Modal.confirm({
			title: '确定删除此权限？',
			content: '此操作不可撤销，确定继续？',
			onOk: () => {
				this.setState(
					{
						deleteIndex: index,
					},
					this.deleteOk
				);
			},
			onCancel: () => {
				this.setState({
					deleteIndex: -1,
				});
			},
		});
	};

	// 确认删除
	deleteOk = () => {
		const { deleteIndex, rules, namespaceId, organizationId, appId } = this.state;
		const { onDelete } = this.props;
		const assignmentId = rules[deleteIndex].assignmentId;
		const stateParam = { deleteIndex: -1 };
		if (assignmentId) {
			stateParam.showLoading = true;
			callApi({
				api: api.deleteOperationAuthorizations,
				data: {
					appId,
					assignmentId,
					namespaceId,
					orgId: organizationId,
				},
				success: () => {
					message.success('删除成功');
					// this.paginationTable.refresh();
					this.listAuthorizationRelations();
					this.setState({ showLoading: false });
					onDelete && onDelete({ assignmentId, appId });
				},
				error: (err) => {
					this.setState({ showLoading: false });
					message.error(`删除失败 ${err && err.errorDescription ? err.errorDescription : ''}`);
				},
			});
		}
		this.setState(stateParam);
	};

	// 获取管理项目范围
	getProjectDataScope = (allCommunityScopeFlag, projectScope = []) => {
		const { projectsMap } = this.state;
		if (allCommunityScopeFlag === CommunityScopeEnum.ALL) {
			return '全部项目';
		}
		if (allCommunityScopeFlag === CommunityScopeEnum.POSITION) {
			return '根据岗位空间权限';
		}
		const selected = [];
		projectScope.forEach(({ projectId, projectType }) => {
			const project = projectsMap.get(projectType === 'EhCommunities' ? '' + projectId : `group${projectId}`);
			selected.push(project?.name || project?.communityName);
		});
		return selected.join('、') || '-';
	};

	// 获取管理企业范围
	getOrganizationDataScope = (allOrgScopeFlag, orgScope = []) => {
		const { departmentsMap } = this.state;
		if (allOrgScopeFlag) {
			return '全公司';
		}
		const selected = [];
		orgScope.forEach((departmentId) => {
			selected.push(departmentsMap.get(departmentId));
		});
		return selected.join('、') || '-';
	};

	// 获取自定义数据
	getCustomData = (customData = []) => {
		return customData.map((data) => data.displayName).join('、') || '-';
	};

	// 获取功能权限
	getOperations = (allOperationFlag, assignedOperations = []) => {
		if (allOperationFlag) {
			return '全部权限';
		}

		const assigned = [];
		assignedOperations.forEach((item) => {
			const { categoryName, operations = [] } = item;
			assigned.push(`${categoryName}(${operations.map((opera) => opera.name).join('、')})`);
		});
		return assigned.join(';') || '-';
	};

	// 导出
	onExport = () => {
		const { organizationId: orgId, namespaceId, appId, showDepartment, showProject } = this.state;
		const { customizeLabelList = [] } = this.props;
		const params = {
			namespaceId,
			orgId,
			appId,
			orgScopeFlag: showDepartment ? 1 : 0,
			communityScopeFlag: showProject ? 1 : 0,
		};
		if (customizeLabelList.length === 1) {
			params.customScope1Flag = 1;
		} else if (customizeLabelList.length === 2) {
			params.customScope1Flag = 1;
			params.customScope2Flag = 1;
		}
		const { envType = '' } = window;
		let url = '';
		if (envType === 'wepark') {
			url = `${window.location.protocol + '//' + window.location.host}/zuolin/private/evh${
				api.exportOperationAuthorizations
			}${addQueryParams(params)}`;
		} else {
			url = `${window.location.protocol + '//' + window.location.host}/evh${
				api.exportOperationAuthorizations
			}${addQueryParams(params)}`;
		}
		window.location.href = url;
		// callApi({
		// 	api: api.exportOperationAuthorizations,
		// 	data: params,
		// 	success: () => {
		// 		message.success('导出成功，请到文件下载中心下载');
		// 	},
		// 	error: () => {
		// 		message.error('导出失败，请稍后重试');
		// 	}
		// });
	};

	render() {
		const { addRule, state, props, listAuthorizationRelations } = this;
		const { pageAnchor, showLoading, rules, totalNum, showProject, showDepartment, allPrivileges } = state;
		const { moduleId, conditionType, appId = '', customizeLabelList = [], showPrivilege, customizeNum } = props;
		const [customizeLabel1 = '自定义数据范围1', customizeLabel2 = '自定义数据范围2'] = customizeLabelList;
		// customizeLabel1 = customizeLabel1.length > 8 ? customizeLabel1.substring(0, 8) + '...' : customizeLabel1;
		// customizeLabel2 = customizeLabel2.length > 8 ? customizeLabel2.substring(0, 8) + '...' : customizeLabel2;

		return (
			<Fragment>
				{/* <RightGroupManagement /> */}
				<Button type="primary" onClick={() => void addRule({ moduleId, conditionType, appId })}>
					新增规则
				</Button>
				<Button className={prefixCls + '-export-btn'} onClick={this.onExport} disabled={rules.length === 0}>
					导出
				</Button>
				{/* <PaginationTable
					className={`${prefixCls}-table`}
					ref={node => { this.paginationTable = node; }}
					dataSource={rules}
					columns={this.getColumn()}
					rowKey='id'
					scroll={{ x: true }}
					pageAnchor={pageAnchor}
					onPageChange={listAuthorizationRelations}
					loading={showLoading}
					totalNum={totalNum}
					showSizePagination={true}
				/> */}
				<Spin spinning={showLoading} wrapperClassName={prefixCls + '-spin'}>
					{rules.map((rule, index) => {
						const {
							assignmentId,
							targets = [],
							allCommunityScopeFlag,
							projectScope,
							allOrgScopeFlag,
							orgScope,
							customizeDatum1,
							customizeDatum2,
							allOperationFlag,
							assignedOperations,
						} = rule;
						return (
							<div className={prefixCls + '-rule'} key={assignmentId}>
								<div className={prefixCls + '-rule-content'}>
									<div className={prefixCls + '-rule-item'}>
										<div className={prefixCls + '-rule-item-label'}>授权给：</div>
										<div className={prefixCls + '-rule-item-content'}>
											{targets.map((target) => target.targetName || '').join('、')}
										</div>
									</div>
									{showProject && (
										<div className={prefixCls + '-rule-item'}>
											<div className={prefixCls + '-rule-item-label'}>管理项目范围：</div>
											<div className={prefixCls + '-rule-item-content'}>
												{this.getProjectDataScope(allCommunityScopeFlag, projectScope)}
											</div>
										</div>
									)}
									{showDepartment && (
										<div className={prefixCls + '-rule-item'}>
											<div className={prefixCls + '-rule-item-label'}>管理企业范围：</div>
											<div className={prefixCls + '-rule-item-content'}>
												{this.getOrganizationDataScope(allOrgScopeFlag, orgScope)}
											</div>
										</div>
									)}
									{customizeNum > 0 && (
										<div className={prefixCls + '-rule-item'}>
											<div className={prefixCls + '-rule-item-label'}>{`${customizeLabel1}：`}</div>
											<div className={prefixCls + '-rule-item-content'}>{this.getCustomData(customizeDatum1)}</div>
										</div>
									)}
									{customizeNum > 1 && (
										<div className={prefixCls + '-rule-item'}>
											<div className={prefixCls + '-rule-item-label'}>{`${customizeLabel2}：`}</div>
											<div className={prefixCls + '-rule-item-content'}>{this.getCustomData(customizeDatum2)}</div>
										</div>
									)}
									{showPrivilege && (
										<div className={prefixCls + '-rule-item'}>
											<div className={prefixCls + '-rule-item-label'}>功能权限：</div>
											<div className={prefixCls + '-rule-item-content'}>
												{this.getOperations(allOperationFlag, assignedOperations)}
											</div>
										</div>
									)}
								</div>
								<div className={prefixCls + '-rule-operate'}>
									<a onClick={() => this.editRule(rule)}>编辑</a>
									<a onClick={() => this.confirmDelete(index)}>删除</a>
								</div>
							</div>
						);
					})}
					{!showLoading && rules.length === 0 && <div className={prefixCls + '-rule-empty'}>暂无数据</div>}
				</Spin>
			</Fragment>
		);
	}
}

AuthorizeByRule.propTypes = {
	ownerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	ownerType: PropTypes.string,
	// 自定义组件标题列表，标题最多8个字，未定义时为：自定义范围+下标
	customizeLabelList: PropTypes.array,
	// 自定义组件个数，如果是对接了自定义组件，必传
	customizeNum: PropTypes.number,
	onDelete: PropTypes.func,
	moduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	// 是否展示管理项目范围
	showProjectScope: PropTypes.bool,
	// 是否展示企业范围
	showDepartmentScope: PropTypes.bool,
	// 是否展示功能权限
	showPrivilege: PropTypes.bool,
};

AuthorizeByRule.defaultProps = {
	customizeNum: 0,
	customizeLabelList: [],
	showPrivilege: true,
};

export default withRouter(AuthorizeByRule);
